import { Box, Card, Radio } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { getSimLabel } from 'utils/common';

interface Props {
	simDetails?: any;
	index: number;
	simSelected: number;
	setSimSelected: (arg: number) => void;
	simFailed: boolean;
}

const SimSelection: React.FC<Props> = ({ simDetails, index, simSelected, setSimSelected, simFailed }) => {
	const [failure, setFailure] = useState<boolean>(false);
	useEffect(() => {
		if (simFailed == simDetails?.slot) setFailure(true);
	}, [simFailed]);

	const handleSimSelection = () => {
		logAnalyticsEvent({
			trigger_point: 'Clicks on SIM Selection',
			Product: 'AutoPayUPI',
			Flow: 'SetupUPI',
			Screen: 'Setup',
			Module: 'SimSelectionCard',
			Element: 'CTA',
			Action: 'Tapped',
			ctaType: 'selectSIM' + index + 1,
		});
		setSimSelected(index);
	};

	return (
		<div className="mt9">
			<Card className="p5">
				<div className="flex flex-row" style={{ width: '100%' }}>
					<div style={{ width: '10%' }}>
						<img src={getSimLabel(simDetails?.carrier_name, simDetails?.slot).icon} width={'32px'} height={'32px'} />
					</div>
					<div
						className="flex flex-start mx5"
						style={{
							width: '70%',
						}}>
						<div>
							<p className="Regular200 uppercase grey-dark">Sim {index + 1}</p>
							<p className={!failure ? 'SemiBold400 black' : 'SemiBold400 disabled'}>
								{simDetails.phone ? simDetails.phone.slice(-10) : simDetails.carrier_name}
							</p>
						</div>
					</div>

					<div className="flex flex-end">
						{!simFailed ? (
							<Radio size="medium" checked={simSelected === index} onClick={handleSimSelection} />
						) : (
							<Box className="br1 danger-light-background content-center p2 mb4" width={'80px'}>
								<p className="danger">Not Linked </p>
							</Box>
						)}
					</div>
				</div>
			</Card>
		</div>
	);
};

export default SimSelection;
